import scrollBlog from '../modules/scrollBlog';
import filterBlog from '../modules/filterBlog';
import searchInternas from './../modules/searchInternas';
let ajax = $("#ajax").val();
if (ajax !== "") {
    console.log(ajax);
    scrollBlog();
}
$("#miniLoader").fadeOut(0);
searchInternas();
filterBlog();


